var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerySatisfied(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5488 35C27.2138 35 35.0488 27.165 35.0488 17.5C35.0488 7.83502 27.2138 0 17.5488 0C7.88384 0 0.0488281 7.83502 0.0488281 17.5C0.0488281 27.165 7.88384 35 17.5488 35Z",
    fill: "url(#paint0_radial_321_82)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.5488 35C27.2138 35 35.0488 27.165 35.0488 17.5C35.0488 7.83502 27.2138 0 17.5488 0C7.88384 0 0.0488281 7.83502 0.0488281 17.5C0.0488281 27.165 7.88384 35 17.5488 35Z",
    fill: "url(#paint1_radial_321_82)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5488 35C27.2138 35 35.0488 27.165 35.0488 17.5C35.0488 7.83502 27.2138 0 17.5488 0C7.88384 0 0.0488281 7.83502 0.0488281 17.5C0.0488281 27.165 7.88384 35 17.5488 35Z",
    fill: "url(#paint2_radial_321_82)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5488 35C27.2138 35 35.0488 27.165 35.0488 17.5C35.0488 7.83502 27.2138 0 17.5488 0C7.88384 0 0.0488281 7.83502 0.0488281 17.5C0.0488281 27.165 7.88384 35 17.5488 35Z",
    fill: "url(#paint3_radial_321_82)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6131 23.3189C29.624 23.2204 29.635 23.122 29.6459 23.0345C29.624 22.7173 29.4272 22.422 29.11 22.3126C28.9459 22.247 28.7709 22.247 28.5959 22.2907C25.0193 23.2861 21.3006 23.8001 17.549 23.8001C13.7975 23.8001 10.0787 23.297 6.50215 22.2907C6.33809 22.247 6.15215 22.247 5.98809 22.3126C5.68184 22.4329 5.48496 22.7064 5.45215 23.0236C5.46309 23.1329 5.47402 23.2423 5.4959 23.3626L5.69277 24.1829C5.73652 24.3361 5.79121 24.5001 5.85684 24.6751C7.08184 27.5407 10.2756 32.5829 17.56 32.5829C24.8334 32.5829 28.0272 27.5298 29.2631 24.6642C29.3178 24.5111 29.3725 24.3689 29.4053 24.2267L29.6131 23.3189Z",
    fill: "url(#paint4_radial_321_82)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5484 31.7844C20.3703 31.7844 22.536 30.975 24.1875 29.8266C22.3719 28.9844 20.1844 28.4375 17.5484 28.4375C14.9125 28.4375 12.7141 28.9844 10.8984 29.8375C12.5609 30.9859 14.7266 31.7844 17.5484 31.7844Z",
    fill: "url(#paint5_radial_321_82)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4055 24.1939L29.6023 23.3517C29.6242 23.2314 29.6352 23.122 29.6352 23.0236C29.6133 22.7064 29.4055 22.4329 29.0992 22.3126C28.9352 22.247 28.7602 22.247 28.5852 22.2907C25.0086 23.2861 21.2898 23.8001 17.5383 23.8001C13.7867 23.8001 10.068 23.297 6.49141 22.2907C6.32734 22.247 6.14141 22.247 5.97734 22.3126C5.67109 22.4329 5.47422 22.7064 5.44141 23.0236C5.45234 23.122 5.46328 23.2423 5.47422 23.3626L5.67109 24.1939C5.71484 24.347 5.76953 24.5111 5.83516 24.6751C6.32734 25.8345 7.14766 27.3439 8.41641 28.7329C7.22422 27.3111 8.68984 26.5345 11.3258 26.8517C13.9508 27.1689 17.5383 27.1798 17.5383 27.1798C17.5383 27.1798 21.1258 27.1689 23.7508 26.8517C26.3758 26.5345 27.8523 27.322 26.6602 28.7329C27.9398 27.3439 28.7492 25.8345 29.2414 24.6751C29.307 24.5001 29.3617 24.347 29.4055 24.1939Z",
    fill: "url(#paint6_linear_321_82)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5486 24.5982C13.7643 24.5982 10.0236 24.0951 6.40332 23.0889L6.44707 23.5811C6.53457 24.5217 7.22363 25.2982 8.14238 25.5061C11.2158 26.1842 14.3658 26.5232 17.5377 26.5232C20.9611 26.5232 24.3518 26.1295 27.6549 25.342C28.1471 25.2217 28.508 24.8061 28.5627 24.3029L28.683 23.0998C25.0736 24.0951 21.333 24.5982 17.5486 24.5982Z",
    fill: "url(#paint7_radial_321_82)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5053 7.3827C9.32405 7.91864 8.54748 8.99052 8.32873 10.1718C7.28967 9.54833 5.97717 9.41708 4.79592 9.95302C2.88186 10.8171 2.03967 13.0702 2.90373 14.9733C4.80686 19.1843 12.835 20.1249 12.835 20.1249C12.835 20.1249 17.4287 13.4858 15.5256 9.26395C14.6725 7.37177 12.4194 6.51864 10.5053 7.3827Z",
    fill: "url(#paint8_radial_321_82)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12.0807 7.04346C15.34 9.20908 15.3838 13.956 13.7979 16.0231C12.0479 18.3091 10.1994 18.4403 6.08691 18.0575C9.07285 19.6872 12.8354 20.1247 12.8354 20.1247C12.8354 20.1247 17.4291 13.4856 15.526 9.26377C14.9025 7.88564 13.5244 7.05439 12.0807 7.04346Z",
    fill: "url(#paint9_radial_321_82)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.5053 7.3827C9.32405 7.91864 8.54748 8.99052 8.32873 10.1718C7.28967 9.54833 5.97717 9.41708 4.79592 9.95302C2.88186 10.8171 2.03967 13.0702 2.90373 14.9733C4.80686 19.1843 12.835 20.1249 12.835 20.1249C12.835 20.1249 17.4287 13.4858 15.5256 9.26395C14.6725 7.37177 12.4194 6.51864 10.5053 7.3827Z",
    fill: "url(#paint10_radial_321_82)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.5053 7.3827C9.32405 7.91864 8.54748 8.99052 8.32873 10.1718C7.28967 9.54833 5.97717 9.41708 4.79592 9.95302C2.88186 10.8171 2.03967 13.0702 2.90373 14.9733C4.80686 19.1843 12.835 20.1249 12.835 20.1249C12.835 20.1249 17.4287 13.4858 15.5256 9.26395C14.6725 7.37177 12.4194 6.51864 10.5053 7.3827Z",
    fill: "url(#paint11_radial_321_82)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M7.4316 10.4669C8.14253 11.1232 7.88003 12.5779 6.83003 13.7154C5.78004 14.8529 4.35816 15.2357 3.63629 14.5794C2.92535 13.9232 3.18785 12.4685 4.23785 11.331C5.28785 10.1935 6.70972 9.81068 7.4316 10.4669Z",
    fill: "url(#paint12_radial_321_82)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M11.3581 7.89701C12.0909 8.21419 12.2768 9.42825 11.7628 10.6095C11.2487 11.7798 10.2424 12.4689 9.49869 12.1517C8.75494 11.8345 8.57994 10.6204 9.09401 9.43919C9.60807 8.26888 10.6143 7.57982 11.3581 7.89701Z",
    fill: "url(#paint13_radial_321_82)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M10.9867 8.27942C12.9883 8.08254 15.8102 9.89817 14.4539 14.3607C13.6445 17.0294 12.2555 18.8232 9.75078 19.5013C11.4898 19.9825 12.8461 20.1466 12.8461 20.1466C12.8461 20.1466 17.4398 13.5075 15.5367 9.28567C14.6727 7.3716 12.4195 6.52942 10.5164 7.39348C9.33516 7.92942 8.55859 9.00129 8.33984 10.1825C8.33984 10.1825 9.5211 8.4216 10.9867 8.27942Z",
    fill: "url(#paint14_linear_321_82)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5642 9.94193C29.3829 9.40599 28.0595 9.53724 27.0314 10.1716C26.8126 8.97943 26.036 7.91849 24.8548 7.38255C22.9407 6.52943 20.6985 7.38255 19.8345 9.29662C17.9423 13.5076 22.5689 20.1357 22.5689 20.1357C22.5689 20.1357 30.5861 19.1732 32.4782 14.9513C33.3314 13.0482 32.4782 10.7951 30.5642 9.94193Z",
    fill: "url(#paint15_radial_321_82)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.8658 10.8936C32.4127 14.7654 28.8799 17.9482 26.2768 18.1342C23.4002 18.342 22.0877 17.0404 19.6377 13.7154C20.3924 17.0295 22.558 20.1467 22.558 20.1467C22.558 20.1467 30.5752 19.1842 32.4674 14.9623C33.1018 13.5514 32.8174 11.9764 31.8658 10.8936Z",
    fill: "url(#paint16_radial_321_82)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.5642 9.94193C29.3829 9.40599 28.0595 9.53724 27.0314 10.1716C26.8126 8.97943 26.036 7.91849 24.8548 7.38255C22.9407 6.52943 20.6985 7.38255 19.8345 9.29662C17.9423 13.5076 22.5689 20.1357 22.5689 20.1357C22.5689 20.1357 30.5861 19.1732 32.4782 14.9513C33.3314 13.0482 32.4782 10.7951 30.5642 9.94193Z",
    fill: "url(#paint17_radial_321_82)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.5642 9.94193C29.3829 9.40599 28.0595 9.53724 27.0314 10.1716C26.8126 8.97943 26.036 7.91849 24.8548 7.38255C22.9407 6.52943 20.6985 7.38255 19.8345 9.29662C17.9423 13.5076 22.5689 20.1357 22.5689 20.1357C22.5689 20.1357 30.5861 19.1732 32.4782 14.9513C33.3314 13.0482 32.4782 10.7951 30.5642 9.94193Z",
    fill: "url(#paint18_radial_321_82)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M26.2104 9.67992C26.1886 10.6534 24.9198 11.419 23.3776 11.3862C21.8354 11.3534 20.5995 10.544 20.6104 9.57055C20.6323 8.59711 21.901 7.83149 23.4432 7.8643C24.9964 7.89711 26.2323 8.70648 26.2104 9.67992Z",
    fill: "url(#paint19_radial_321_82)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M30.7496 10.9156C31.0011 11.6812 30.2136 12.6218 28.9996 13.0156C27.7855 13.4093 26.5933 13.114 26.3417 12.3484C26.0902 11.5828 26.8777 10.6421 28.0918 10.2484C29.3058 9.84371 30.498 10.15 30.7496 10.9156Z",
    fill: "url(#paint20_radial_321_82)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M30.2145 10.8829C31.691 12.2501 32.1941 15.5642 27.9613 17.511C25.4238 18.6704 23.1598 18.8235 20.9941 17.4017C21.7816 19.0204 22.5691 20.147 22.5691 20.147C22.5691 20.147 30.5863 19.1845 32.4785 14.9626C33.3316 13.0485 32.4785 10.8064 30.5645 9.9423C29.3832 9.40636 28.0598 9.53761 27.0316 10.172C27.0316 10.161 29.1426 9.88761 30.2145 10.8829Z",
    fill: "url(#paint21_linear_321_82)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_321_82",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1057 10.4078) scale(21.1115)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB92E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_321_82",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1057 10.4078) scale(16.6093)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_321_82",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.83394 17.6536) rotate(32.7366) scale(9.26553 6.76282)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB672A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4286,
    stopColor: "#DC641B",
    stopOpacity: 0.2846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#C25E00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_321_82",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.274 17.6393) rotate(147.263) scale(9.26553 6.76282)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB672A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4286,
    stopColor: "#DC641B",
    stopOpacity: 0.2846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#C25E00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_321_82",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.5473 27.4237) scale(9.29851 9.2985)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_321_82",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.6816 30.5153) scale(7.39818 2.23692)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2479,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C20000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_321_82",
    x1: 29.509,
    y1: 25.5003,
    x2: 5.73484,
    y2: 25.5003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#512D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2200"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_321_82",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.5476 24.8051) scale(20.3944 20.3944)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9BCBE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_321_82",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.30315 12.6676) rotate(-53.7393) scale(10.8385 8.59653)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2479,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8639,
    stopColor: "#C20000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_321_82",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.27385 11.9513) rotate(-53.7394) scale(9.3316 7.40132)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2479,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C20000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_321_82",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.30315 12.6676) rotate(-53.7393) scale(10.8385 8.59653)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_321_82",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.3639 14.4376) rotate(-50.6229) scale(7.91122 3.90871)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD2719",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD2719",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_321_82",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.53269 12.5403) rotate(-46.0208) scale(2.81228 1.74698)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_321_82",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.4275 10.0368) rotate(-65.0908) scale(2.3284 1.44646)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_321_82",
    x1: 16.1832,
    y1: 24.0518,
    x2: 9.9511,
    y2: 7.01146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#860805"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD2719",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_321_82",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.4583 11.0406) rotate(-5.26571) scale(10.8384 8.59671)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2479,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8639,
    stopColor: "#C20000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_321_82",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.975 10.5437) rotate(-5.26571) scale(9.33152 7.40147)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2479,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C20000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_321_82",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.4583 11.0406) rotate(-5.26571) scale(10.8384 8.59671)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_321_82",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.5086 15.9899) rotate(-2.1516) scale(7.91143 3.90876)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD2719",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD2719",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_321_82",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.4161 9.63825) rotate(2.44968) scale(2.81233 1.74717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_321_82",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.5604 11.6235) rotate(-16.6196) scale(2.32847 1.44648)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_321_82",
    x1: 21.857,
    y1: 25.2348,
    x2: 30.4821,
    y2: 9.27262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#860805"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD2719",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerySatisfied);
export default __webpack_public_path__ + "static/media/Very Satisfied.58944bf11f9b419f0c2a85aa94c5ef50.svg";
export { ForwardRef as ReactComponent };